// extracted by mini-css-extract-plugin
module.exports = {"window":"FactorinWindow_window__2LJH5","fillGray":"FactorinWindow_fillGray__24VRv"};